import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';

import StoreName        from '../../../../State/Shared/Constants/StoreName';
import Playback         from '../../../../State/Stores/Playback/Playback';
import * as TestIds     from '../../../Shared/Constants/TestIds';
import composeTokenList from '../../Util/composeTokenList';
import renderTestId     from '../../Util/renderTestId';

import * as styles from '../../Styles/counter.css';

interface ICurrentTimeProps extends IConnectProps<Playback> {
    areControlsIdle: boolean;
}

@connect(StoreName.PLAYBACK)
class CurrentTime extends React.Component<ICurrentTimeProps> {
    public shouldComponentUpdate(nextProps: ICurrentTimeProps): boolean {
        return (
            nextProps.value.humanReadableCurrentTime !== this.props.value.humanReadableCurrentTime ||
            nextProps.areControlsIdle !== this.props.areControlsIdle
        );
    }

    public render(): JSX.Element {
        const testId = composeTokenList([
            TestIds.PLAYER_COUNTER_CURRENT_TIME,
            [!this.props.areControlsIdle, TestIds.PLAYER_COUNTER_CURRENT_TIME_VISIBLE]
        ]);

        return (
            <div
                className={styles.counter}
                data-test-id={renderTestId(testId)}
            >
                {this.props.value.humanReadableCurrentTime}
            </div>
        );
    }
}

export default CurrentTime;